<template>
  <div
    class="data-table-filter"
    :class="{ 'dashboard-node--highlight': highlighted }"
  >
    <BaseFilterBar
      v-if="showFilterBar"
      :search-placeholder="searchPlaceholder"
      :search="search"
      :filters="filters"
      :values="filterValues"
      @filter-change="handleFilterChange"
      @submit="handleSubmit"
    >
      <template
        v-if="actions.length"
        v-slot:actions
      >
        <BaseButtonAction
          v-for="(action, index) in actions"
          :key="index"
          :label="action.label"
          color="primary"
          type="text"
          size="medium"
          :data-field="actionDataField(index)"
          @click.native="handleAction(action)"
        />
      </template>
    </BaseFilterBar>
    <div
      v-if="actions.length && !showFilterBar"
      class="data-table-filter__actions"
    >
      <BaseButtonAction
        v-for="(action, index) in actions"
        :key="index"
        :label="action.label"
        color="primary"
        type="text"
        size="medium"
        :data-field="actionDataField(index)"
        @click.native="handleAction(action)"
      />
    </div>
    <BaseDashboardTable
      :columns="columns"
      :rows="rows"
      :item-key="itemKey"
      :hide-default-footer="false"
      :group-by="groupBy"
      :group-subtotals="groupSubtotals"
      :server-items-length="serverItemsLength"
      :options="options"
      @detail="$emit('row-detail', $event)"
      @action="$emit('action', $event)"
      @update:options="handleOptionsChange"
    />
  </div>
</template>

<script>
import BaseDashboardTable from './BaseDashboardTable.vue'
import BaseFilterBar from './BaseFilterBar.vue'
import BaseButtonAction from './BaseButtonAction.vue'
import FilterBarEvents from '../../mixins/FilterBarEvents.js'
import DashboardHighlightOnRender from '../../mixins/DashboardHighlightOnRender'
import { sanitizeDataField } from './dataFieldUtils'

const FILTER_BAR_THRESHOLD = 10

export default {
  name: 'BaseDataTableFilter',
  components: { BaseDashboardTable, BaseFilterBar, BaseButtonAction },
  mixins: [FilterBarEvents, DashboardHighlightOnRender],
  props: {
    actions: {
      type: Array,
      required: false,
      default: () => []
    },
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    },
    searchPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    search: {
      type: String,
      required: false,
      default: ''
    },
    forceFilterBar: {
      type: Boolean,
      required: false,
      default: false
    },
    filters: {
      type: Array,
      required: false,
      default: () => []
    },
    groupBy: {
      type: String,
      required: false,
      default: ''
    },
    groupSubtotals: {
      type: Object,
      required: false,
      default: () => ({})
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    },
    instance: {
      type: String,
      required: false,
      default: ''
    },
    filterValues: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    showFilterBar() {
      return this.forceFilterBar || this.rows.length > FILTER_BAR_THRESHOLD
    }
  },
  methods: {
    handleOptionsChange(newOptions) {
      this.$emit('update:options', { instance: this.instance, options: newOptions })
    },
    handleAction(action) {
      this.$emit('action', { action, columns: this.columns, rows: this.rows })
    },
    actionDataField(index) {
      return sanitizeDataField(`${this.instance}-action-${index}`)
    }
  }
}
</script>

<style lang="scss">
.data-table-filter {
  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-bottom: 8px;
  }
}
</style>
